<template>
  <div
    class="calllog__message"
    :class="[`calllog__message--${callInfo.direction}`]"
  >
    <div class="calllog__icon">
      <img
        v-if="callInfo.direction === 'outbound' && callInfo.cdr.status === 'no_answer'"
        alt="status icon"
        src="@/assets/images/icons/call-outgoing.svg"
      />

      <vsx-icon
        v-else-if="callInfo.status === 'answered'"
        color="#43B284"
        icon-name="Call"
        :size="16"
        type="linear"
      />
      <vsx-icon
        v-else
        color="#FF3B30"
        icon-name="Call"
        :size="16"
        type="linear"
      />
    </div>
    <div class="calllog__history">
      {{ callHistoryText }}

      <p class="calllog__date">{{ callTime }}</p>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'CallLogItem',
    props: {
      callInfo: {
        type: Object,
        required: true,
      },
    },
    computed: {
      // eslint-disable-next-line
      callHistoryText() {
        if (this.callInfo.direction === 'inbound') {
          if (this.callInfo.status === 'answered') {
            return this.$t('call_center.you_received_an_audio_call_and_spoke_for', {
              time: this.answeredCallTime,
            });
          } else if (this.callInfo.status === 'missed' || this.callInfo.status === 'canceled') {
            return this.$t('call_center.you_missed_a_call', {
              reason: this.$t(`call_center.no_answer_reason.${this.callInfo.cdr.status}`),
            });
          }
        } else if (this.callInfo.direction === 'outbound') {
          if (this.callInfo.status === 'answered') {
            return this.$t('call_center.you_made_an_audio_call_and_spoke_for', {
              time: this.answeredCallTime,
            });
          } else if (
            this.callInfo.status === 'missed' ||
            this.callInfo.status === 'canceled' ||
            this.callInfo.status === 'no_answer' ||
            this.callInfo.status === 'not_found' ||
            this.callInfo.status === 'unavailable' ||
            this.callInfo.status === 'busy'
          ) {
            return this.$t('call_center.you_tried_to_make_an_audio_call', {
              reason: this.$t(`call_center.no_answer_reason.${this.callInfo.cdr.status}`),
            });
          }
        }
      },
      callTime() {
        const startCallTime = moment(this.callInfo.call_time);
        // Check if the date is today
        const isToday = startCallTime.isSame(new Date(), 'day');

        return isToday
          ? this.$t('call_center.today_at', { time: startCallTime.format('h:mm A') })
          : startCallTime.format('MMM D, YYYY, h:mm A');
      },
      // eslint-disable-next-line
      answeredCallTime() {
        if (this.callInfo.status === 'answered') {
          const answeredTime = moment(this.callInfo.cdr.startTimeAnswer);
          const endTime = moment(this.callInfo.cdr.endCallTime);
          // Calculate the difference in milliseconds
          const duration = moment.duration(endTime.diff(answeredTime));

          // Extract minutes and seconds
          const minutes = Math.floor(duration.asMinutes());
          const seconds = duration.seconds();

          // Format the difference
          if (minutes === 0) {
            return this.$t('call_center.duration_in_seconds', { seconds });
          }
          return this.$t('call_center.duration_in_minutes_and_seconds', { minutes, seconds });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .calllog {
    &__message {
      width: fit-content;
      display: flex;
      gap: 8px;
      &--inbound {
        padding: 16px;
        border-radius: 15px;
        border: 1px solid var(--color-gray-200);
        background-color: var(--color-gray-50);
      }
      &--outbound {
        padding: 8px;
        border-radius: 10px;
        border: 1px solid var(--color-base-200, #98daf6);
        background-color: var(--color-base-50, #eff7fe);
        margin-inline-start: auto;
      }
    }
    &__user {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: var(--gray900, #1a1a1a);
      margin-inline: 4px;
    }
    &__history,
    &__date {
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: var(--gray500, #808080);
    }
    &__history {
      font-size: 14px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &__date {
      font-size: 12px;
      flex-basis: 100%;
      margin-block-start: 4px;
    }
    &__icon {
      line-height: 0;
    }
  }
</style>
